import './components/burger.js';
import './components/modal.js';
import './components/toast.js';
import './components/cookie.js';
import './components/scroll-btn.js';
import './components/slider.js';
import './components/form.js';
// import './components/gallery.js';
import './components/steps.js';
// import './components/dropdown.js';
import './components/toggle-btn.js';
